import { render, staticRenderFns } from "./CategorySubject.vue?vue&type=template&id=39e79470&"
import script from "./CategorySubject.vue?vue&type=script&lang=js&"
export * from "./CategorySubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports